<template>
  <div>
      <SaleMaster addNew="/sales/sales-quotation/" type="SQ" ></SaleMaster>
  </div>
</template>

<script>
import SaleMaster from './master.vue'
export default {
   components: { SaleMaster }
}
</script>

<style>

</style>